import { gql } from '@apollo/client';

const USER_FIELDS = gql`
  fragment UserFieldsFragment on User {
    id
    firstName
    lastName
    avatar {
      url(transform: { width: 180, height: 180 })
      initials
    }
    email
    primaryPhone {
      e164
      national
    }
    phoneExt
    alternativePhone {
      e164
      national
    }
    phone2Ext
    isFacebookLinked
  }
`;

export const GET_USER_QUERY = gql`
  ${USER_FIELDS}
  query GetUser($id: ID!) {
    user(id: $id) {
      ...UserFieldsFragment
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  ${USER_FIELDS}
  mutation UpdateUser($input: UserUpdateInput!) {
    updateUser(input: $input) {
      ...UserFieldsFragment
    }
  }
`;

export const UPDATE_PROFILE_PHOTO_MUTATION = gql`
  mutation UpdateProfilePhoto($input: UserPhotoUpdateInput!) {
    updateProfilePhoto(input: $input) {
      id
      avatar {
        url(transform: { width: 180, height: 180 })
        initials
      }
    }
  }
`;

export const DELETE_PROFILE_PHOTO_MUTATION = gql`
  mutation DeleteProfilePhoto($input: UserDeletePhotoInput!) {
    deleteProfilePhoto(input: $input) {
      id
      avatar {
        url(transform: { width: 180, height: 180 })
        initials
      }
    }
  }
`;

export const UPDATE_LANGUAGE_PREFERENCE_MUTATION = gql`
  mutation UpdateLanguagePreference($input: UserLanguagePreferenceUpdateInput!) {
    updateLanguagePreference(input: $input) {
      id
      language
    }
  }
`;

export const UPDATE_PASSWORD_MUTATION = gql`
  mutation UpdatePassword($input: UserPasswordUpdateInput!) {
    updatePassword(input: $input) {
      success
    }
  }
`;

export const GENERATE_PRESIGNED_URL = gql`
  mutation GeneratePresignedUrl($input: GeneratePresignedUrlInput!) {
    userGeneratePresignedUrl(input: $input) {
      url
      fields {
        key
        value
      }
    }
  }
`;

export const DEAUTHORIZE_FACEBOOK_MUTATION = gql`
  mutation DeauthorizeFacebook {
    deauthorizeFacebook {
      id
      isFacebookLinked
    }
  }
`;

export const PERSONAL_API_KEY_QUERY = gql`
  query PersonalApiKey {
    personalApiKey {
      masked
    }
  }
`;

export const REGENERATE_PERSONAL_API_KEY_MUTATION = gql`
  mutation RegeneratePersonalApiKey {
    regeneratePersonalApiKey {
      apiKey
      masked
    }
  }
`;
